import React from 'react';
import { DatePicker } from 'antd';
import './style.css';
import { Button } from '../Button';
import moment from 'moment';
const { RangePicker } = DatePicker;
const DateRangePicker = ({
  onChange = () => {},
  onClick,
  title,
  hideButton = false,
  defaultValue = null,
  showTimePicker = true,
  disabledFutureDates = true,
  excludeLastMins = null,
  ...otherProps
}) => {
  const effectiveEndTime = excludeLastMins && excludeLastMins > 0 ? moment().subtract(excludeLastMins, 'minutes') : moment().endOf('day');

  const disabledRangeTime = (_, type) => {
    let current = moment();
    if (excludeLastMins && excludeLastMins > 0) {
      current = moment().subtract(excludeLastMins, 'minutes');
    }
    const isToday = _?.isSame(current, 'day');
    if (isToday) {
      const currentHour = current?.hour();
      const currentMinute = current?.minute();
      return {
        disabledHours: () => {
          return Array.from({ length: 24 }, (_, i) => i).filter((hour) => hour > currentHour);
        },
        disabledMinutes: (selectedHour) => {
          if (selectedHour === currentHour) {
            return Array.from({ length: 60 }, (_, i) => i).filter((minute) => minute > currentMinute);
          }
          return [];
        },
      };
    }
    return {};
  };
  return (
    <div className='dateRange'>
      <RangePicker
        className='datePicker'
        defaultValue={defaultValue}
        disabledTime={disabledRangeTime}
        onChange={onChange}
        {...(showTimePicker && {
          showTime: {
            format: 'HH:mm',
            defaultValue: [moment().startOf('day'), effectiveEndTime],
          },
        })}
        disabledDate={disabledFutureDates ? (current) => current.isAfter(moment().endOf('day')) : false}
        format='YYYY-MM-DD HH:mm'
        ranges={{
          Today: [moment().startOf('day'), effectiveEndTime.clone()],
          Yesterday: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
          'Last 7 Days': [moment().subtract(6, 'days').startOf('day'), effectiveEndTime.clone()],
          'Last 30 Days': [moment().subtract(29, 'days').startOf('day'), effectiveEndTime.clone()],
          'Last 90 Days': [moment().subtract(89, 'days').startOf('day'), effectiveEndTime.clone()],
          'Last Month': [moment().subtract(1, 'months').startOf('month'), moment().subtract(1, 'months').endOf('month')],
          'This Month': [moment().startOf('month'), effectiveEndTime.clone()],
        }}
        {...otherProps}
      />
      {!hideButton && (
        <Button className='button-theme rounded-lg' onClick={onClick}>
          {title}
        </Button>
      )}
    </div>
  );
};
export default DateRangePicker;
